/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	Nav,
	Badge,
	Collapse,
	NavItem,
	//NavLink,
	NavbarToggler,
} from "reactstrap";

import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { toggleSetting } from "../../store/ui.settings/actions";
import HeaderSearch from "./HeaderSearch";
import Menu, { ISidebarMenuItem } from "../../Menu";
import { withRouter } from "../withRoute";

export interface HeaderHorizontalProps {
	toggleSetting: typeof toggleSetting;
}

type IState = {
	navSearchOpen: boolean,
	isOpen: boolean,
}

const HeaderHorizontal = (props: any ) => {
	const [state, setState] = useState<IState>({ navSearchOpen: true, isOpen: false });

	useEffect(() => {
		setState(oldState => ({ ...oldState, isOpen: false }));
	}, [props.router.location]);

	/*
	useEffect(() => {
		props.router.navigate.listen(() => {
			setState(oldState => ({
				...oldState,
				isOpen: false
			}));
		});
	}, [props.router.navigate]);
	*/

	const toggle = () =>
		setState(oldState => ({
			...oldState,
			isOpen: !oldState.isOpen
		}))

	return (
		<header className="topnavbar-wrapper" id='page-header'>
			<nav className="navbar topnavbar navbar-expand-lg navbar-light">
				<div className="navbar-header">
					<Logo />
					<Collapse isOpen={state.isOpen} navbar>
						<Nav navbar className="mr-auto flex-column flex-lg-row">
							{Menu.map((item, i) => MenuItem(item, i))}
						</Nav>
					</Collapse>
					<HeaderSearch location={props.router.location} />
					<NavbarToggler onClick={toggle} />
				</div>
			</nav>
		</header>
	);
}

const MenuItem = (item: ISidebarMenuItem, i: number) => {
	/** map menu config to string to determine which element to render */
	const itemType = (item: ISidebarMenuItem) => {
		if (item.heading) return "heading";
		return item.submenu ? "submenu" : "menu";
	};

	if (itemType(item) === "menu") {
		return (
			<NavItem key={i}>
				<Link className="nav-link" to={item.path!}>
					{item.icon && <div className={`img-fluid ${item.icon}`}></div>}
					<span>{item.name}</span>
				</Link>
			</NavItem>
		);
	}
	else if (itemType(item) === "submenu") {
		return (
			<UncontrolledDropdown nav inNavbar key={i}>
				<DropdownToggle nav>{item.name}</DropdownToggle>
				<DropdownMenu className="animated fadeIn">
					{item.submenu!.map((sitem, si) => {
						return (
							<Link to={sitem.path!} key={si} className="dropdown-item">
								{sitem.label && (
									<Badge
										tag="div"
										className="float-right"
										color={sitem.label.color}
									>
										{sitem.label.value}
									</Badge>
								)}
								{sitem.icon && <div className={sitem.icon}></div>}
								<span>{sitem.name}</span>
							</Link>
						);
					})}
				</DropdownMenu>
			</UncontrolledDropdown>
		);
	}
};

const Logo = () => (
	<a className="navbar-brand"
		href={`${process.env.REACT_APP_BASE_FOLDER || "/"}`} >
		<div className="brand-logo">
			<img
				className="img-fluid"
				src= {process.env.PUBLIC_URL + "/img/license-portal.svg"}
				alt="License Portal"
			/>
		</div>
		<div className="brand-logo-collapsed"></div>
	</a>
);

const mapDispatchToProps = (dispatch: Dispatch) => ({
	toggleSetting: bindActionCreators(toggleSetting, dispatch),
});

export default connect(null, mapDispatchToProps)(withRouter(HeaderHorizontal));
